import React from "react";
import { Link } from "react-router-dom";
import { useShopInfoStore } from "../../store";
import { observer } from "mobx-react-lite";
import { Popover, Spin } from "antd";
import classNames from "classnames";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import CountValue from "../../CountValue";

interface WarehouseAreaProps {}

const WarehouseArea: React.FC<WarehouseAreaProps> = function (props) {
    const store = useShopInfoStore();

    const inventoryWarningCount = store.getCount(
        store.anyInventoryThresholdConfigured === false ? null : store.inventoryWarningCount,
    );

    const inventoryWarningCountEl = (
        <div className={classNames("count", inventoryWarningCount === store.NoStatistics && "error")}>
            <CountValue value={inventoryWarningCount === store.NoStatistics ? "未开启" : inventoryWarningCount} />
        </div>
    );

    return (
        <div className="warehouse-area">
            <div className="warehouse-area-item">
                <Popover content="已启用库存管理的店铺和商品，库存状态为警戒的商品数">
                    <div className="title">库存预警商品</div>
                </Popover>

                {inventoryWarningCount === store.NoStatistics ? (
                    <Popover
                        content={
                            <div>
                                <span>库存管理未设置商品库存警戒值</span>
                                <Link to="/features/warehouseManagement" className="ml5">
                                    去设置
                                </Link>
                            </div>
                        }
                    >
                        <span>{inventoryWarningCountEl}</span>
                    </Popover>
                ) : (
                    inventoryWarningCountEl
                )}
            </div>

            <Link
                to="/features/warehouseManagement?fromHome=1"
                className="operation"
                onClick={() => {
                    collectEvent(DataTrackEvent.CLICK_HOME_CONTENT, {
                        content: "查看库存",
                    });
                }}
            >
                查看库存
            </Link>
        </div>
    );
};

export default observer(WarehouseArea);
